import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {Company, CompanyState} from "@/modules/company/types";
import {getCompanies, getCompany, updateCompany} from "@/services/company";

export const state: CompanyState = {
  company: {
    name: "",
    address: "",
    tax_id: "",
    tax_situation_document: "",
    fax: ""
  }
}

const actions: ActionTree<CompanyState, RootState> = {
  async GET_COMPANY(_, id) {
    return await getCompany(id);
  },
  async GET_COMPANIES() {
    return await getCompanies();
  },
  async UPDATE_COMPANY(_, payload) {
    return await updateCompany(payload);
  }
}

const mutations: MutationTree<CompanyState> = {
  SET_COMPANY(state, company: Company) {
    state.company = company;
  }
}

const getters: GetterTree<CompanyState, RootState> = {
  COMPANY(state): Company {
    const {company} = state;
    return {...company};
  }
}

export const company: Module<CompanyState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
